import React from "react";
import { CTAButton } from "./CTAButton";
import { images } from "../data/content";
export function FinalCTA() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-132" data-mp="3udp0mtecbqr2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-133" data-mp="c6iqbhenhf1c">
        <h2 className="font-serif text-[30px] font-bold leading-[1.12] text-white sm:text-4xl md:text-5xl" data-id="element-134" data-mp="c83pxlftno62">
          Are you ready for a more structured approach to insulin resistance nutrition care?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-white/75 sm:text-lg" data-id="element-135" data-mp="m2voarh8af1w">
          You don't need to rebuild your reference materials every time you prepare a consultation. Start with a structured
          system designed to help you organize assessments, nutrition discussions, progress reviews, and ongoing follow-up.
        </p>

        <img src={images.hero} alt="Insulin Resistance Nutrition Blueprint™ Complete Collection" className="mx-auto mt-6 w-full max-w-md" loading="lazy" data-id="element-136" data-mp="14w7we967w59t" />

        <p className="mt-4 font-serif text-xl font-bold text-gold sm:text-2xl" data-id="element-137" data-mp="2c4ocezz2fd7s">Complete Collection</p>
        <p className="mt-2 text-[16px] font-semibold text-white" data-id="element-138" data-mp="2h3hoqp2m8y6d">
          Six Clinical Volumes · Five Specialized Professional Tools · One Visual Clinical Navigation Framework
        </p>

        <div className="mt-8" data-id="element-139" data-mp="2r1xfgqxqe5fc">
          <CTAButton tone="dark" label="Yes, I want Insulin Resistance Nutrition Blueprint™" note="Just $27 USD · Instant Digital Access · One-Time Payment · 7-Day Money-Back Guarantee" data-id="element-140" data-mp="2r275ufmouelk" />
        </div>
      </div>
    </section>;
}